export default "__VITE_ASSET__0b600550__"